import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.css'],
})
export class WarningModalComponent implements OnInit {
  modalData: { [key: string]: any } = {};
  userAction: string;
  closeButtonText: string;

  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    if (this.modalData.actionID == null) this.modalData.actionID == 'actionButton';
    if (this.modalData.actionType == null) this.modalData.actionType = 'danger';
    this.closeButtonText = this.modalData.closeButtonText != null ? this.modalData.closeButtonText : 'Cancel';
  }

  actionClicked() {
    this.userAction = this.modalData.modalAction;
    this.bsModalRef.hide();
  }

  cancelClicked() {
    this.userAction = 'close';
    this.bsModalRef.hide();
  }
}
